// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","247":"component---src-pages-details-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"223":"d7f856fada034d247193","247":"5b7357156913e0babf9f","293":"25c407e1d8e5de4f7a74","454":"2980f87c17f26afd343c"}[chunkId] + ".js";
};